import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForWebSeries extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'customFilter',
      type: 'selectCustom',
      options: [{ property: 'visibleInList', value: 1 }],
    },
  ];

  defaultColumns = [
    'id',
    'headline',
    'visibleInList',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'visibleInList',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
